module.exports = __webpack_public_path__ + "img/title-b24a3619.faf1382f.png";